export default __webpack_public_path__ + "static/media/extrasbnwcrop.6bff60be.png";